import { Badge } from '@reflex/ui/components/ui/badge';
import type { ResolvedModelDefault } from '@reflex/shared';

interface ModelDefaultOriginBadgeProps {
  origin: ResolvedModelDefault['origin'];
}

export function ModelDefaultOriginBadge({ origin }: ModelDefaultOriginBadgeProps) {
  switch (origin) {
    case 'admin':
      return (
        <Badge variant="default" className="text-2xs">
          admin configured
        </Badge>
      );
    case 'service_default':
      return (
        <Badge variant="secondary" className="text-2xs">
          service default
        </Badge>
      );
    case 'system_recommended':
      return (
        <Badge variant="secondary" className="text-2xs text-status-info">
          system recommended
        </Badge>
      );
    case 'fallback':
      return (
        <Badge variant="outline" className="text-2xs">
          fallback
        </Badge>
      );
    case 'unset':
      return null;
    default: {
      const exhaustiveCheck: never = origin;
      return exhaustiveCheck;
    }
  }
}
